import { colors } from '../../constants/colors/Colors';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    headServiceOverview: {
        width: '100%',
    },
    headServiceOverviewContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            display: 'inline',
         
        },
    },
    headServiceOverviewLeft: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    leftHead: {
        width: '100%',
        marginLeft: 9,
        textAlign: 'left',
    },

    serviceInnerText: {
        display: 'flex',
        alignItems: 'center',
        // overflow: 'auto',
        // whiteSpace: 'wrap',
        flexWrap: 'wrap'
    },
    serviceInnerWhiteDiv: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: 100,
        backgroundColor: '#ffffff',
        padding: '7px 10px',
        marginRight: 9,
    },
    serviceText: {
        margin: 0,
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: 26,
        fontFamily: 'Roboto',
        marginBottom: 10,
        color: colors.primary
    },

    text: {
        margin: 0,
        color: '#5B6773',
        fontfamily: 'Roboto-Regular',
        fontSize: 13,
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: 50,
        marginLeft: 5,
        backgroundColor: colors.primary
    },
    btnContainer: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            marginTop: 20
        },
    },
    headBtn: {
        margin: 0,
        padding: 0,
        width: 150,
        fontWeight: "500",
        fontSize: 15,
        color: "#091E42",
        fontFamily: "Roboto",
        textTransform: "none",
        border: "transparent",
        borderRadius: 0,
    },
    btnRoot: {
        "&:hover":
            { backgroundColor: '#F4F6F8' }
    },
    root: {
        marginTop: 50,
        flexGrow: 1,
        borderRadius: 12,
        border: '1px solid #D4DDE4',
        // width: '100% !important',
        paddingBottom: 36
    },
    appBar: {
        borderRadius: '12px 12px 0 0',
        backgroundColor: '#E6EDF3',
        height: 82,
        justifyContent: 'center',
        padding: '0px 20px',
        // width:'100%',
        // backgroundColor:'green',
        // overflowY:'scroll'
        

    },
    selected: {
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        background: 'linear-gradient(#824ED2, #B07DFF)',
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor:'pointer',
    },
    notSelected: {
        cursor:'pointer',
        width: 'auto',
        paddingLeft: 10,
        paddingRight: 10,
        height: 42,
        borderRadius: 6,
        marginRight: 55,
        whiteSpace: 'nowrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor:'pointer',
    },
    tabHead: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto-SemiBold',
    },
    activeTab: {
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        color: '#FFFFFF',
        fontFamily: 'Roboto-SemiBold',
    },
    tabsBodyContainer: {
        paddingLeft: 30,
        paddingRight: 30,
        width: '100%',
        "@media (max-width: 720px)": {
            paddingLeft: 0,
            paddingRight: 0,
         
          },
    },
    tableTitleRow: {
        display: 'inline-flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        marginTop: 10,
    },

    tableTitle: {
        color: colors.titleColor,
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
    },

    titleForAll: {
        letterSpacing: '-0.001em',
        fontSize: 22,
        fontWeight: '400',
        color: colors.primary,
    },



}));